module.exports = __webpack_public_path__ + "img/Muses-ex-Echoes2.1de88c85.png";